import * as z from "zod";

/** Canonical product ids for merchant unified onboarding. */
export const UNIFIED_ONBOARDING_PRODUCT_IDS = ["recover"] as const;

export type UnifiedOnboardingProductId =
  (typeof UNIFIED_ONBOARDING_PRODUCT_IDS)[number];

export const UnifiedOnboardingProductIdSchema = z.enum(
  UNIFIED_ONBOARDING_PRODUCT_IDS,
);

export function isUnifiedOnboardingProductId(
  value: string,
): value is UnifiedOnboardingProductId {
  return UnifiedOnboardingProductIdSchema.safeParse(value).success;
}

export function parseUnifiedOnboardingProductId(
  value: string | null | undefined,
): UnifiedOnboardingProductId | undefined {
  if (value == null) {
    return undefined;
  }
  const parsed = UnifiedOnboardingProductIdSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}
